import { Outlet } from './Outlet';
import { defineComponent, h, renderSlot } from 'vue';
export const Route = defineComponent({
    name: 'Route',
    props: {
        path: {
            default: '',
            required: false,
            type: String,
        },
        caseSensitive: {
            default: false,
            required: false,
            type: Boolean,
        },
        element: {
            default: () => Outlet,
            required: false,
            type: [Object, Function],
        },
    },
    setup(props, { slots }) {
        return () => renderSlot(slots, 'element', undefined, () => [h(props.element)]);
    },
});
